export const blog = {
  title: "Blog",
  subtitle: "Stay updated with the latest news from Araria",
  readMore: "Read more",
  latestPosts: "Latest posts",
};
